import { useEffect } from "react";

export const useFavicon = (tenantConfig) => {
  useEffect(() => {
    if (!tenantConfig?.faviconUrl) return;
    const favicon = document.getElementById("favicon");
    if (favicon) favicon.href = tenantConfig.faviconUrl;
  }, [tenantConfig]);
};
